import React,{Component} from 'react';
import classnames from 'classnames';

import BrandPersonalization from './Brand';
import Workflow from './Workflow';
import Loading from '../../common/Loading';
import './index.scss';

function accordionData(auth) {
  const { domain, role } = auth;
  const CS_ROLES = ['CS_ADMIN', 'CS_SETUP', 'CS_SALES'];

  const customizationValues = [
    {
      title: domain !== 'DENTAL' ? 'Brand personalization' : 'Personalization',
      description: 'Customize your logo and names',
      component: (props, onValueChange, onSave, onCancel, removeLogo, webbookingconfig, auth, business) => (
        <BrandPersonalization
          props={props}
          onValueChange={onValueChange}
          onSave={onSave}
          onCancel={onCancel}
          removeLogo={removeLogo}
          webbookingconfig={webbookingconfig}
          auth={auth}
          business={business}
        />
      )
    }
  ];

  if (CS_ROLES.includes(role)) {
    customizationValues.push({
      title: 'Workflow Setup',
      description: 'Customize your workflow',
      component: (props, onValueChange, onSave, onCancel, removeLogo, webbookingconfig, auth, business, getWebBookingWorfkflow) => (
        <Workflow
          props={props}
          onValueChange={onValueChange}
          onSave={onSave}
          onCancel={onCancel}
          removeLogo={removeLogo}
          webbookingconfig={webbookingconfig}
          auth={auth}
          business={business}
          getWebBookingWorfkflow={getWebBookingWorfkflow}
        />
      )
    });
  }

  return customizationValues;
}

class ConversationList extends Component {
  
  constructor(props){
    super(props);
    this.state ={
      accordion: -1,
      greetings:'Hi there  How can i help you today?',
      file_name:'',
      global_logo_file:'',
      business_name: '',
      assistant_name:'Studio Assiatant',
      actioncolor:'#BB2C2C',
      brandcolor:'#000000',
      require_email:false,
      email_capture_message:'',
      collapse_on_start:true,
      logo:''
    }
  }
  componentDidMount =()=>{
    if(this.props.business&& this.props.business.id){
      this.setState({
        business_name:this.props.business.info.BUSINESS_NAME
      })
    }
    if(this.props.webbookingconfig.getWebpreference!==true && this.props.webbookingconfig.webchatpreference && Object.keys(this.props.webbookingconfig.webchatpreference).length !== 0){
      const { webchatpreference } = this.props.webbookingconfig;
      const { booking_widget_personalization} = webchatpreference;
    this.setState({
        global_logo_file: (booking_widget_personalization.logo)?booking_widget_personalization.logo:null,
        actioncolor:  booking_widget_personalization.action_color,
        brandcolor:  booking_widget_personalization.background_color,
    })
    }
  }
  componentWillReceiveProps(nextProps){
    if(nextProps.business && nextProps.business.isInfoFetched && nextProps.business.isInfoFetched!==this.props.business.isInfoFetched){
      this.setState({
        business_name:nextProps.business.info.BUSINESS_NAME
      })
    }
    if(nextProps.webbookingconfig.getWebpreference!==true && nextProps.webbookingconfig.webchatpreference && Object.keys(nextProps.webbookingconfig.webchatpreference).length !== 0){
      const { webchatpreference } = this.props.webbookingconfig;
      const { booking_widget_personalization} = webchatpreference;
    this.setState({
        global_logo_file: (booking_widget_personalization.logo)?booking_widget_personalization.logo:null,
        actioncolor:  booking_widget_personalization.action_color,
        brandcolor:  booking_widget_personalization.background_color,
    })
    }
  }
  openAccordion = (index)=>{
    if(index!==this.state.accordion){
    this.setState({
      accordion:index
    })
    }else{
      this.setState({
        accordion:-1
      })
    }
  }

  onValueChange =(event,target)=>{
    if(target === 'actioncolor'|| target==='brandcolor'){
      this.setState({
        [target]:event.hex
      })
    }else{
    this.setState({
      [target]:event.target.value
    })
    if(target==='collapse_on_start'){
      this.onSave(event,'collapse');
    }
    }
  }
  removeLogo = ()=>{
    this.setState({
      global_logo_file:null,
    })
  }
  onCancel =()=>{
    const { webchatpreference } = this.props.webbookingconfig;
      const { booking_widget_personalization} = webchatpreference;
    this.setState({
        global_logo_file: (booking_widget_personalization.logo)?booking_widget_personalization.logo:null,
        actioncolor:  booking_widget_personalization.action_color,
        brandcolor:  booking_widget_personalization.background_color,
        accordion:-1
    })
  }
  onSave =(event,type)=>{
    console.log('event-event',event,type);
    switch(type){
      case 'brandings': let params= {
                                    global_logo_file:this.state.global_logo_file,
                                    file_name:this.state.file_name,
                                    action_color:this.state.actioncolor,
                                    background_color:this.state.brandcolor,
                                    };
                      
                        this.props.postWebBookingPref(params.action_color,params.background_color,params.global_logo_file); break;
      case 'logo': this.setState({ global_logo_file: event }); break;
      case 'workflow': this.props.postWebBookingWorfkflow(event); break;      
      default: break;
    }
  }
  render(){
    const {accordion} = this.state;
    const { webbookingconfig, auth, business, getWebBookingWorfkflow } = this.props;
    
    return (
      accordionData(auth).map((custom,index)=>{
      return (<div key={index}>
              <div className="customization-list" onClick={()=>this.openAccordion(index)}>
                <div className="tabs">
                    <div className={classnames('title',{'selected-accordion': index===accordion})}>{custom.title}</div>
                    <div className="description">{custom.description}</div>
                </div>
                <div className={classnames('acrdn-btn',{'selected-accordion': index===accordion})}><i className="material-icons">keyboard_arrow_down</i></div>
              </div>
              { index===accordion && 
                <>
                {!webbookingconfig.getWebGreetings?
                (<div className='accordion-body'>
              {custom.component(this.state, this.onValueChange, this.onSave, this.onCancel, this.removeLogo, webbookingconfig, auth, business, getWebBookingWorfkflow)}
                </div>)
                :(
                  <div className="add-campaign_loader">
                  <Loading />
                  </div>
                )
                }
                </>
              } 
              </div>)
      }
      )
    )

  }
};

export default ConversationList;
